import { QLevel, QUALITY, setQuality } from '../platform/quality';
import { VOL, setVolume } from '../platform/audio-engine';

/* 畫質設定的三顆按鈕（開始畫面）。

   為什麼放在開始畫面而不是暫停選單：這一輪加的東西有一半是**建立成本**
   （地面與建築的法線圖要跑 Sobel），開局之後才切會卡一下 ——
   而開始畫面是唯一「卡一下不影響任何事」的地方。
   ⚠️ 切換仍然是即時生效的（`platform/quality.ts` 的訂閱），
   所以除錯時可以用 `__CHASSIS_DEBUG.quality('low')` 在戰場上直接比較。 */

var LEVELS: { id: QLevel, name: string, hint: string }[] = [
  { id: 'high', name: '高', hint: '泛光 · 2048 陰影 · 濕地反射 · 表面法線' },
  { id: 'medium', name: '中', hint: '泛光 · 1024 陰影 · 表面法線（無反射）' },
  { id: 'low', name: '低', hint: '只保留真陰影與接地影' },
];

export function initQualityUI() {
  var row = document.getElementById('qRow');
  if (!row) return;
  var hint = document.getElementById('qHint');
  row.innerHTML = LEVELS.map(function (l) {
    return '<button class="btn small q" data-q="' + l.id + '">' + l.name + '</button>';
  }).join('');
  function paint() {
    var bs = row!.querySelectorAll('.q');
    for (var i = 0; i < bs.length; i++) {
      var on = (bs[i] as HTMLElement).dataset.q === QUALITY.level;
      bs[i].classList.toggle('on', on);
    }
    var cur = LEVELS.filter(function (l) { return l.id === QUALITY.level; })[0];
    if (hint && cur) hint.textContent = cur.hint;
  }
  row.addEventListener('click', function (e) {
    var b = (e.target as HTMLElement).closest('.q') as HTMLElement;
    if (!b || !b.dataset.q) return;
    setQuality(b.dataset.q as QLevel);
    paint();
  });
  paint();
  initVolumeUI();
}

/** 音量兩條滑桿。**放在開始畫面而不是暫停選單**，理由跟畫質一樣：
    這是「開局前設好」的東西，而且音量要調就是要一邊聽一邊調，
    開始畫面沒有戰鬥聲蓋著反而調不準 —— 所以兩條都即時生效，
    使用者可以開一場、按 Esc 回來再調（存 localStorage）。 */
function initVolumeUI() {
  var host = document.getElementById('vRow');
  if (!host) return;
  /* 三條而不是兩條（2026-08-06 加音樂）。**音樂一定要能單獨關掉** ——
     長時間玩的人第一個關的就是它，而把它綁在音效上等於逼他連音效一起關。 */
  var KS: { k: 'master' | 'sfx' | 'music'; zh: string }[] = [
    { k: 'master', zh: '總' }, { k: 'sfx', zh: '音效' }, { k: 'music', zh: '音樂' }
  ];
  host.innerHTML = '';
  for (var i = 0; i < KS.length; i++) {
    (function (it) {
      var lab = document.createElement('label');
      lab.className = 'vol';
      lab.innerHTML = it.zh + '<input type="range" min="0" max="1" step="0.05" value="'
        + VOL[it.k] + '"><i>' + Math.round(VOL[it.k] * 100) + '</i>';
      var inp = lab.querySelector('input') as HTMLInputElement;
      var num = lab.querySelector('i') as HTMLElement;
      inp.oninput = function () {
        var v = parseFloat(inp.value);
        setVolume(it.k, v);
        num.textContent = String(Math.round(v * 100));
      };
      host!.appendChild(lab);
    })(KS[i]);
  }
}
